var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import UAParser from "ua-parser-js";
import "axios";
const STORED_LOG = "storedLog";
const SENDING_LOG = "sendingLog";
const REFER_PAGE_ID = "referPageId";
const SEND_INTERVAL = 20;
const ALIVE_TIME = 100;
var sendTimer = {
  interval: null,
  init(time = SEND_INTERVAL) {
    const realTime = time * 1e3;
    this.interval = setInterval(() => {
      const currentTime = new Date().getTime();
      if (currentTime - core.lastSendTime >= core.config.bulk_time_limit * 1e3) {
        core.resend();
      }
    }, realTime);
  },
  clear() {
    clearInterval(this.interval);
  }
};
let intervalId;
const triggerHB = (opportunity) => {
  core.record("HB", {
    log_id: generateUUId(),
    event_ts: Date.now(),
    log_type: "HB",
    opportunity,
    exter: {
      page_id: core.page_id
    }
  });
};
const hbTimer = (opportunity) => {
  intervalId = setInterval(() => {
    triggerHB(opportunity);
  }, 10 * 1e3);
};
const coldStartTimer = () => {
  triggerHB(3);
  clearInterval(intervalId);
  hbTimer(1);
};
const hotStartTimer = () => {
  triggerHB(5);
  clearInterval(intervalId);
  hbTimer(1);
};
const tabChange = () => {
  triggerHB(6);
  clearInterval(intervalId);
  hbTimer(2);
};
require("md5");
const generateUUId = () => {
  var temp_url = URL.createObjectURL(new Blob());
  var uuid = temp_url.toString();
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf("/") + 1).replace(/-/g, "");
};
const clone = (vueOb) => {
  return JSON.parse(JSON.stringify(vueOb));
};
const generateHeaders = (options) => {
  var _a, _b, _c, _d, _e;
  const parser = new UAParser();
  const ua = parser.getResult();
  const state = options.store.state;
  return {
    "Content-type": "application/json;charset=utf-8",
    "X-Timestamp": Date.now(),
    "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    "X-Role": (state == null ? void 0 : state.user) ? 1 : 0,
    "x-deviceId": localStorage.getItem("deviceId") || "",
    "X-Brand": ua.device.vendor || ua.os.name,
    "X-Model": ua.device.model || ua.os.version,
    browser: ua.browser.name,
    browser_version: ua.browser.version,
    "X-Uid": (_b = (_a = state == null ? void 0 : state.user) == null ? void 0 : _a.userInfo) == null ? void 0 : _b.uid,
    "X-RecruiterId": (_e = (_d = (_c = state == null ? void 0 : state.user) == null ? void 0 : _c.userInfo) == null ? void 0 : _d.roleInfo) == null ? void 0 : _e.id,
    "X-SessionId": core.appId
  };
};
const initApp = (app, isCold) => {
  if (isCold) {
    app.appId = generateUUId();
    sendTimer.init();
    coldStartTimer();
  }
  app.appBootstrapTime = new Date().getTime();
  app.asaq_id = generateUUId();
};
function on(target, type, handler) {
  if (target.addEventListener) {
    target.addEventListener(type, handler, false);
  } else {
    target.attachEvent("on" + type, function(event) {
      return handler.call(target, event);
    }, false);
  }
}
const encode = (arr) => {
  const splitCode = String.fromCharCode(20) + String.fromCharCode(21);
  return arr.map((i) => JSON.stringify(i)).join(splitCode);
};
const delay = (func) => {
  setTimeout(func, 10);
};
if (typeof window !== "undefined") {
  var storage = window.localStorage;
}
function stringify(val) {
  return val === void 0 || typeof val === "function" ? val + "" : JSON.stringify(val);
}
function deserialize(value) {
  if (typeof value !== "string") {
    return void 0;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return value || void 0;
  }
}
const localStorage$1 = {
  get: function(key) {
    return deserialize(storage.getItem(key));
  },
  set: function(key, value) {
    return storage.setItem(key, stringify(value));
  },
  clear: function() {
    return storage.clear();
  },
  remove: function(key) {
    return storage.removeItem(key);
  },
  each: function(callback) {
    for (var i = 0; i < storage.length; i++) {
      var key = storage.key(i);
      if (callback(this.get(key), key) === false)
        break;
    }
  },
  excludeGet(key, value) {
    const item = this.get(key);
    this.set(key, value);
    return item;
  }
};
var core = {
  appId: null,
  appBootstrapTime: null,
  asaq_id: "",
  config: {
    "immediately": [],
    "bulk_count": 150,
    "bulk_time_limit": 30
  },
  lastSendTime: new Date().getTime(),
  enterTime: "",
  page_id: "",
  pvpd_id: "",
  refer_page_id: "",
  Vue: null,
  vm: {},
  commonExtra: {},
  options: {},
  pageEvent: {},
  unloaded: false,
  hbTemp: {},
  record(type, detail) {
    const commonDetail = {
      page_id: this.page_id,
      ts: Date.now()
    };
    if (type === "enterPage" || type === "leavePage" || type === "leaveAllPage" || type === "leavePageTemp") {
      commonDetail.during_time = type === "enterPage" ? 0 : new Date().getTime() - this.enterTime;
      commonDetail.pvpd_id = this.pvpd_id;
      commonDetail.refer_page_id = this.refer_page_id;
    }
    let body = __spreadValues(__spreadValues({}, detail), commonDetail);
    if (body.log_type !== "AS" && body.log_type !== "AQ" && body.log_type !== "HB") {
      body.exter = this.resolveExtra(body.exter);
    }
    if (body.exter === false) {
      return;
    }
    if (body.exter.page_id) {
      body.page_id = body.exter.page_id;
      delete body.exter.page_id;
    }
    if (type === "HB" && body.opportunity === 3 && !this.page_id) {
      this.hbTemp = body;
      return;
    }
    if (type === "enterPage" && this.hbTemp.log_id && this.page_id) {
      delete this.hbTemp.page_id;
      this.hbTemp.exter.page_id = this.page_id;
      this.send(this.hbTemp);
      this.hbTemp = {};
    }
    if (body.log_type === "AS") {
      delete body.page_id;
      this.send(body);
    } else if (body.log_type === "AQ") {
      delete body.page_id;
      this._send(body);
    } else {
      if (this.page_id || body.page_id) {
        this._send(clone(body));
      }
    }
  },
  send(body) {
    if (!body)
      return;
    if (Array.isArray(body)) {
      if (body.length === 0)
        return;
      if (body.length === 1)
        body = body[0];
    }
    const sendingLog = localStorage$1.get(SENDING_LOG) || {};
    const date = Date.now();
    sendingLog[date] = body;
    localStorage$1.set(SENDING_LOG, sendingLog);
    const headers = generateHeaders(this.options);
    const { output, send: send2 } = this.options;
    if (output === "console") {
      console.warn("[log] You are in DEV mode and only record logs in console:");
      console.warn(`[log] log:`, body);
    } else {
      const fn = send2(body, headers);
      if (fn && typeof fn.then === "function" && typeof fn.catch === "function") {
        fn.then((res) => {
        }).catch(() => {
          this.setStoredLog(body);
        }).finally(() => {
          this.lastSendTime = new Date().getTime();
          const sendingLog2 = localStorage$1.get(SENDING_LOG);
          delete sendingLog2[date];
          localStorage$1.set(SENDING_LOG, sendingLog2);
        });
      }
      return fn;
    }
  },
  externalSend(log_type, modular_id, exter) {
    const page_id = exter.page_id;
    delete exter.page_id;
    return this._send({
      log_type,
      modular_id,
      page_id: page_id || this.page_id,
      exter
    });
  },
  setStoredLog(body) {
    let storedLog = localStorage$1.get(STORED_LOG);
    if (storedLog) {
      if (Array.isArray(body)) {
        storedLog = storedLog.concat(body);
      } else {
        storedLog.push(body);
      }
    } else {
      if (Array.isArray(body)) {
        storedLog = body;
      } else {
        storedLog = [body];
      }
    }
    localStorage$1.set(STORED_LOG, storedLog);
  },
  resolveExtra(extra) {
    if (typeof extra === "function") {
      extra = extra.call(this.vm);
      if (extra === false) {
        return extra;
      }
    }
    const combineExtra = __spreadValues(__spreadValues({}, this.commonExtra), extra);
    Object.keys(combineExtra).forEach((key) => {
      const val = combineExtra[key];
      if (typeof val === "function") {
        combineExtra[key] = val.call(this.vm);
      }
    });
    return combineExtra;
  },
  resolvePageId(pageId) {
    return typeof pageId === "function" ? pageId.call(this.vm) : pageId;
  },
  _send(body) {
    const { bulk_count: count, immediately } = this.config;
    if (this.isSendImmediately(immediately, body)) {
      return this.send(body);
    } else {
      this.setStoredLog(body);
      const storedLog = localStorage$1.get(STORED_LOG);
      if (storedLog && storedLog.length >= count) {
        this.resend();
      }
    }
  },
  isSendImmediately(immediately, body) {
    return true;
  },
  resend(logs) {
    const storedLog = logs || localStorage$1.excludeGet(STORED_LOG, []);
    if (storedLog) {
      this.send(storedLog);
    }
  },
  resendByCount(count = 5) {
    const allLogs = localStorage$1.excludeGet(STORED_LOG, []);
    const sendLogs = allLogs.splice(0, count);
    localStorage$1.set(STORED_LOG, allLogs);
    this.resend(sendLogs);
  },
  clear() {
    localStorage$1.set(STORED_LOG, []);
  },
  reset() {
    this.commonExtra = {};
    this.clear();
  },
  sendMessage(message, extra) {
    this._send({
      "log_type": "Message",
      message,
      exter: extra
    });
  },
  sendError(err_type, message, exter) {
    this._send({
      "log_type": "ER",
      "err_type": err_type || "default_error",
      "message": message,
      "exter": exter
    });
  },
  setCommonExtra(key, val) {
    this.commonExtra[key] = val;
  },
  clearSendingLog() {
    const sendingLog = localStorage$1.excludeGet(SENDING_LOG, {});
    Object.values(sendingLog).forEach((body) => {
      this.send(body);
    });
  }
};
var aliveTimer = {
  startTime: new Date().getTime(),
  clearIntervalId: null,
  isTimeout: false,
  resetTime: () => {
  },
  reEnterCb: () => {
  },
  init(timeOut = 60, timeoutCb = () => {
  }, reEnterCb = () => {
  }) {
    const realTimeout = timeOut * 1e3;
    this.reEnterCb = reEnterCb;
    this.resetTime = () => {
      this.startTime = new Date().getTime();
    };
    this.addListener(this.resetTime);
    this.clearIntervalId = setInterval(() => {
      if (!this.isTimeout) {
        const currentTime = new Date().getTime();
        if (currentTime - this.startTime >= realTimeout) {
          timeoutCb();
          this.isTimeout = true;
        }
      }
    }, realTimeout / 10);
  },
  clear() {
    clearInterval(this.clearIntervalId);
    this.removeListener(this.resetTime);
    const onceListener = () => {
      this.startTime = new Date().getTime();
      if (this.isTimeout) {
        this.isTimeout = false;
        this.reEnterCb();
      }
      this.removeListener(onceListener);
    };
    this.addListener(onceListener);
  },
  addListener(resetTime) {
    if (typeof window !== "undefined") {
      on(window, "keydown", resetTime);
      on(window, "mousemove", resetTime);
      on(window, "click", resetTime);
    }
  },
  removeListener(resetTime) {
    if (typeof window !== "undefined") {
      window.removeEventListener("keydown", resetTime, true);
      window.removeEventListener("mousemove", resetTime, true);
      window.removeEventListener("click", resetTime, true);
    }
  }
};
const triggerAS = (start_type) => {
  core.record("AS", {
    log_id: generateUUId(),
    event_ts: Date.now(),
    log_type: "AS",
    start_type,
    build_type: core.options.env === "prod" ? "release" : "debug",
    asaq_id: core.asaq_id,
    exter: {}
  });
};
const triggerAQ = (start_type) => {
  core.record("AQ", {
    log_id: generateUUId(),
    event_ts: Date.now(),
    log_type: "AQ",
    start_type,
    build_type: core.options.env === "prod" ? "release" : "debug",
    asaq_id: core.asaq_id,
    during_time: new Date().getTime() - core.appBootstrapTime,
    exter: {}
  });
};
const triggerPD = (extra, pageId) => {
  var _a, _b;
  const page_id = pageId || core.page_id;
  if (page_id && ((_a = core.pageEvent[page_id]) == null ? void 0 : _a.isStop)) {
    core.pageEvent[page_id].isStop = false;
    return;
  }
  let detail = {
    log_type: "PD",
    exter: extra || ((_b = core.pageEvent[page_id]) == null ? void 0 : _b.value) || {}
  };
  core.record("leavePage", detail);
  core.refer_page_id = core.page_id;
  aliveTimer.clear();
};
function pd(options) {
  if (typeof window !== "undefined") {
    window.onbeforeunload = function(e) {
      core.unloaded = true;
      triggerPD();
      triggerAQ(0);
      triggerHB(4);
      localStorage.setItem(REFER_PAGE_ID, core.page_id);
    };
  }
}
function clickEvent(el, arg, value) {
  const modular_id = arg || "default_click";
  on(el, "click", (e) => {
    delay(() => {
      let detail = {
        log_type: "MC",
        modular_id,
        exter: value
      };
      if (value.modular_id) {
        detail.modular_id = core.resolvePageId(value.modular_id);
        detail.exter = core.resolvePageId(value.extra);
      }
      core.record("click", detail);
    });
  });
}
const triggerPV = (page_id, extra) => {
  let detail = {
    log_type: "PV"
  };
  page_id = core.resolvePageId(page_id);
  const exter = core.resolveExtra(extra);
  core.pageEvent[page_id] = {
    value: exter
  };
  if (exter === false) {
    core.pageEvent[page_id].isStop = true;
    return;
  } else {
    detail.exter = exter;
  }
  if (page_id) {
    core.page_id = page_id;
  }
  aliveTimer.init(ALIVE_TIME, () => {
    triggerPD();
  }, () => {
    triggerPV();
  });
  core.enterTime = new Date().getTime();
  core.pvpd_id = generateUUId();
  core.record("enterPage", detail);
};
const viewRecorded = /* @__PURE__ */ new Map();
function showEvent(el, arg, value = {}, event) {
  delay(() => {
    let pageId = arg || "";
    if (value.page_id) {
      pageId = core.resolvePageId(value.page_id);
      value = value.extra;
    }
    const url = location.href;
    const intersectionObserver = new IntersectionObserver(function(entries) {
      if (entries[0].intersectionRatio <= 0) {
        if (event === "pageview" && url === location.href) {
          triggerPD(null, pageId);
          intersectionObserver.unobserve(el);
        }
        return;
      }
      if (event === "view") {
        if (viewRecorded.has(el)) {
          return;
        } else {
          delay(() => {
            const modular_id = arg;
            let detail = {
              log_type: "MV",
              modular_id,
              exter: value
            };
            if (value.modular_id) {
              detail.modular_id = core.resolvePageId(value.modular_id);
              detail.exter = core.resolvePageId(value.extra);
            }
            core.record("view", detail);
            viewRecorded.set(el, detail);
          });
        }
      } else if (event === "pageview") {
        triggerPV(pageId, value);
      }
    });
    intersectionObserver.observe(el);
  });
}
const bind = (el, binding) => {
  let { value, arg } = binding;
  let events = Object.keys(binding.modifiers).map((modifier) => {
    const splitArr = modifier.split(":");
    if (splitArr[1])
      arg = splitArr[1];
    if (binding.modifiers[modifier]) {
      return splitArr[0];
    }
  });
  if (!events.length)
    events.push("click");
  events.forEach((event) => {
    if (event === "click") {
      clickEvent(el, arg, value);
    }
    if (event === "view" || event === "pageview") {
      showEvent(el, arg, value, event);
    }
  });
};
function moduleInstall() {
  core.Vue.directive("log", {
    bind(el, binding) {
      bind(el, binding);
    },
    componentUpdated(el, binding) {
    }
  });
}
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
function visibilitychange() {
  on(document, "visibilitychange", () => {
    if (core.page_id) {
      if (document.visibilityState === "hidden") {
        if (!core.unloaded && !isMobile()) {
          triggerPD();
          triggerAQ(1);
          tabChange();
        }
      } else if (document.visibilityState === "visible") {
        initApp(core);
        triggerAS(1);
        triggerPV(core.page_id, core.pageEvent[core.page_id].value);
        hotStartTimer();
      }
    }
  });
}
function server() {
  return new Promise((resolve) => {
    resolve({});
  });
}
function install(Vue, options = {}) {
  core.Vue = Vue;
  const {
    env = "prod",
    router,
    send: send2 = (data) => {
      console.log(data);
      return Promise.resolve(data);
    },
    output = "console",
    store = {},
    config = server
  } = options;
  if (!router) {
    console.error("Options router is required!");
    return;
  }
  core.options = {
    env,
    router,
    send: send2,
    output,
    store
  };
  core.clearSendingLog();
  const deviceId = localStorage$1.get("deviceId");
  if (!deviceId) {
    localStorage$1.set("deviceId", generateUUId());
  }
  initApp(core, true);
  triggerAS(0);
  pd();
  moduleInstall();
  visibilitychange();
  if (options.router) {
    options.router.beforeEach((to, from, next) => {
      core.page_id = "";
      next();
    });
  }
  core.refer_page_id = localStorage$1.get(REFER_PAGE_ID) || "";
  config().then((res) => {
    if (res.status && res.status === 200) {
      const config2 = res.data.data;
      if (config2) {
        core.config = config2;
      }
    }
  });
}
var mixin = {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { log: logConfig } = vm.$route.meta;
      core.vm = vm;
      if (logConfig == null ? void 0 : logConfig.commonExtra) {
        Object.keys(logConfig.commonExtra).forEach((key) => {
          const valId = logConfig.commonExtra[key];
          core.setCommonExtra(key, function() {
            return this[valId];
          });
        });
      }
      let pageId = logConfig == null ? void 0 : logConfig.pageId;
      if (pageId && (logConfig == null ? void 0 : logConfig.dynamic)) {
        pageId = function() {
          return this[logConfig.pageId];
        };
      }
      if (!(logConfig == null ? void 0 : logConfig.disablePV)) {
        triggerPV(pageId, logConfig == null ? void 0 : logConfig.extra);
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    triggerPD();
    next();
  }
};
const send = core.externalSend.bind(core);
const resend = core.resend.bind(core);
const logMixin = mixin;
const log = function(Vue, options) {
  try {
    install(Vue, options);
  } catch (err) {
    console.error(err);
  }
};
const triggerColdStart = () => {
  initApp(core, true);
};
export { encode, log, logMixin, resend, send, triggerColdStart, triggerPD, triggerPV };
